module.exports = __webpack_public_path__ + "static/media/flag.f1b2fa97.gif";